var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40417 2.40631L11.8792 0.910472C11.9383 0.901992 11.9985 0.906319 12.0558 0.92316C12.1131 0.940001 12.1661 0.968963 12.2113 1.00808C12.2564 1.0472 12.2926 1.09557 12.3174 1.1499C12.3422 1.20422 12.355 1.26325 12.355 1.32297V18.6946C12.355 18.7543 12.3422 18.8132 12.3174 18.8675C12.2927 18.9217 12.2566 18.9701 12.2115 19.0092C12.1665 19.0483 12.1136 19.0773 12.0564 19.0942C11.9992 19.1111 11.9391 19.1155 11.88 19.1071L1.40333 17.6113C1.20468 17.583 1.02291 17.484 0.891407 17.3324C0.759904 17.1809 0.687502 16.987 0.6875 16.7863V3.23131C0.687502 3.03065 0.759904 2.83673 0.891407 2.68518C1.02291 2.53362 1.20468 2.4346 1.40333 2.40631H1.40417ZM13.1883 2.50881H16.5217C16.7427 2.50881 16.9546 2.5966 17.1109 2.75288C17.2672 2.90916 17.355 3.12112 17.355 3.34214V16.6755C17.355 16.8965 17.2672 17.1084 17.1109 17.2647C16.9546 17.421 16.7427 17.5088 16.5217 17.5088H13.1883V2.50881ZM7.52167 10.0088L9.855 6.67547H7.855L6.52167 8.58047L5.18833 6.67547H3.18833L5.52167 10.0088L3.18833 13.3421H5.18833L6.52167 11.4371L7.855 13.3421H9.855L7.52167 10.0088Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.ed9c8288733660c190d019428005112c.svg";
export { ForwardRef as ReactComponent };